import { render, staticRenderFns } from "./StaffComplianceStatusCard.vue?vue&type=template&id=6f535add&"
import script from "./StaffComplianceStatusCard.vue?vue&type=script&lang=ts&"
export * from "./StaffComplianceStatusCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports